<template>
  <b-btn-group size="sm" class="diet-filter">
    <b-btn v-for="diet in levelDiets" :key="diet.name" :title="diet.name | capitalize"
           :class="{ active: isActive(diet), [diet.name]: true }" @click="setDiet(diet)">
      <img :hidden="isActive(diet)" :src="require(`../../assets/meat-slider/${diet.name}.svg`)" :alt="diet.label"/>
      <img :hidden="!isActive(diet)" :src="require(`../../assets/meat-slider/${diet.name}-on.svg`)" :alt="diet.label"/>
      <span>{{ diet.label }}</span>
    </b-btn>
  </b-btn-group>
</template>

<script>
export default {
  props: ['user', 'diets'],

  data() {
    return {
      levelDiets: this.diets ? this.diets.filter(diet => diet.level) : [],
      currentFilter: this.diet,
    }
  },

  computed: {
    diet() {
      return this.user.restrictions.map(dietName =>
        this.diets.find(diet => diet.name === dietName) || {}
      ).filter(diet => diet && diet.level !== null && diet.level >= 0).sort(diet => diet.level)[0]
    }
  },

  watch: {
    user() {
      this.setDiet(this.diet)
    }
  },

  created() {
    this.setDiet(this.diet)
  },

  methods: {
    isActive(diet) {
      if (!this.currentFilter) return true
      return diet.level <= this.currentFilter.level
    },

    setDiet(diet) {
      this.currentFilter = diet
      this.$emit('change', this.currentFilter)
    },
  },
}
</script>

<style lang="scss">
.diet-filter {
  .btn {
    color: $gray-400;
    background-color: transparent !important;
    border: 0;
    width: 80px;
    font-size: $font-size-xs;

    &.active {
      color: $primary !important;
    }

    &:hover {
      color: $primary;
    }

    &:focus {
      box-shadow: none !important;
    }

    img {
      display: block;
      width: 40px;
      height: 40px;
      overflow: hidden;
      margin: 0 auto 5px auto;
    }
  }
}
</style>